<template>
  <v-footer color="secondary" padless :app="!mobile" inset>
    <v-row justify="space-around" no-gutters>
      <template
        v-if="
          rutaActual &&
          rutaActual !== 'login' &&
          rutaActual !== 'crear_contrasena'
        "
      >
        <v-btn
          v-for="link in links"
          :key="link.name"
          color="white"
          text
          x-small
          :block="mobile"
          rounded
          class="my-1"
          @click="link.text ? copiarTexto(link.text) : ''"
          :href="link.link ? link.link : ''"
          target="_blank"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small left> {{ link.icon }}</v-icon>
              <span
                v-bind="attrs"
                v-on="on"
                @mouseleave="link.text ? (copyText = 'Copiar') : ''"
                :class="mobile ? 'texto-footer' : ''"
              >
                {{ link.name }}
              </span>
            </template>
            <span v-if="link.span">{{ link.span }}</span>
            <span v-else>{{ copyText }}</span>
          </v-tooltip>
        </v-btn>
      </template>
      <v-col class="primary text-center white--text" cols="12">
        ©
        <strong class="link-style">
          <a
            class="white--text text-decoration-none"
            href="https://www.maximizaerp.cl/"
          >
            Maximiza
          </a>
        </strong>
        {{ new Date().getFullYear() }}
        <v-tooltip
          v-if="prod"
          color="white"
          top
          content-class="version-tooltip"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              icon
              small
              absolute
              right
            >
              <v-icon small left> mdi-help-box </v-icon>
            </v-btn>
          </template>
          <span>{{ build }}</span>
        </v-tooltip>
        <div
          v-else
          style="position: absolute; right: 0px; bottom: 0px; margin-right: 4px"
        >
          <span> V. {{ build }} </span>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    copyText: "Copiar",
    build: process.env.VUE_APP_BUILD_DATE,
    prod: process.env.VUE_APP_PROD == 1,

    links: [
      {
        name: "contacto@islacoop.cl",
        icon: "mdi-email",
        text: "contacto@islacoop.cl"
      },
      {
        icon: "mdi-map-marker",
        name: "Av. Santelices 427, Isla De Maipo",
        link: "https://goo.gl/maps/9UGHyPkC1RjD4c6g9",
        span: "Ver en Google Maps"
      },
      { name: "+569 3944 5824", icon: "mdi-whatsapp", text: "+56939445824" },
      { name: "+562 2819 2620", icon: "mdi-phone", text: "+56228192620" }
    ]
  }),
  methods: {
    ...mapActions(["switchDrawer"]),
    copiarTexto(value) {
      navigator.clipboard.writeText(value);
      this.copyText = "Copiado !";
    }
  },
  computed: {
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return false;
      }
    },
    rutaActual() {
      return this.$route.name;
    }
  },

  mounted() {
    if (this.mobile) {
      this.switchDrawer(false);
    }
  }
};
</script>
<style scoped lang="css">
.texto-footer {
  width: min-content;
  white-space: normal;
  flex: auto;
}
.version-tooltip {
  font-size: 10px !important;
  color: black;
  padding: 0px 5px !important;
}
</style>
